import { Injectable, Injector } from "@angular/core";
import { BaseDataService, BaseTabsContainer, ConfirmationDialogButtons, DefaultListTabsComponent, ErrorHandlerService, ModalService, ModalSize, ModelData, ModelDataService, QueryParameter, TabsContainerService } from "yt-ng-framework";
import { FakDokumentView } from "./fak-dokument-view";
import { TranslateService } from "@ngx-translate/core";
import { HttpErrorResponse } from "@angular/common/http";
import { FakDokumentIzvozView } from "./izvoz/fak-dokument-izvoz-view";
import { FakDokument } from "./fak-dokument";
// import { NotificationsService } from "angular2-notifications";
import { CommentComponent } from "src/app/lookups/_forme/comment/comment.component";
// import { SlanjeDokumentaMailomModalUpdateComponent } from "./slanje-dokumenta-mailom/slanje-dokumenta-mailom-modal-update.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GabaritiRobeComponent } from "./gabariti-robe/gabariti-robe.component";
import { List } from "immutable";
import { PoljaZaVelikeLanceComponent } from "./polja-za-velike-lance/polja-za-velike-lance.component";
import { FakDokumentUpdateComponent } from "./fak-dokument-update.component";
import { Router } from "@angular/router";
import { FakDokumentTabsComponent } from "./fak-dokument-tabs.component";

@Injectable({
    providedIn: 'root'
  })
  export class FakDokumentService {
  
    constructor(
        protected baseDataService: BaseDataService,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        // protected modelData:ModelData,
        protected errorService: ErrorHandlerService,
        protected modelDataService: ModelDataService,
         protected router: Router,
        // protected notificationService: NotificationsService,
        // private ngbModalService: NgbModal, private injector: Injector,
        protected tabsContainerService:TabsContainerService<FakDokumentView>
    ) { 
        
    }
  public baseUpdateComponent: FakDokumentUpdateComponent
  public baseTabsComponent: FakDokumentTabsComponent


  private activeTab: string = 'tbList'; 

setActiveTab(tabId: string) {
  this.activeTab = tabId;
  // console.log("Aktivan tab u servisu:", this.activeTab);
}

getActiveTab(): string {
  return this.activeTab;
}

isVisibleOnTbList = () => this.getActiveTab() === 'tbList';
isVisibleOnTbUpdate = () => this.getActiveTab() === 'tbUpdate';

  PrintDispatch(){
    const brojOtpremnice = this.baseUpdateComponent.Item.BrojOtpremnice;
    if (!brojOtpremnice) {
      this.modalService.ShowConfirmationDialog(
        "Obaveštenje",
        "Morate uneti broj otpremnice kako biste mogli da štampate otpremnicu.",
        "alert",
        ConfirmationDialogButtons.Ok
      );
      return; 
    }
      this.translateService
      .get("FAKDISPATCH.SINGULAR")
      .subscribe((translate) => {
        this.modalService
          .ShowPrintDialog(
            translate,
            this.baseUpdateComponent.modelData.MainList.EnablePrintAccountSelection,
            false
            // , this.Item["PodVrstaDokumentaStavkaID"]
          )
          .result.then(
            (value) => {
              this.modalService
                .ShowConfirmationDialog(
                  "Potvrda",
                  "Štampamo i cene na otpremnici?",
                  "question",
                  ConfirmationDialogButtons.YesNo
                )
                .result.then(
                  (result) => {
                    let stampamoCeneNaOtpremnici: boolean = result === true;

              let controllerName: string;
              let controllerMethodName: string;
              if (this.baseUpdateComponent.modelData.MainList.PrintController) {
                controllerName = this.baseUpdateComponent.modelData.MainList.PrintController;
                controllerMethodName = "Printaj";
              } else {
                controllerName = this.baseUpdateComponent.modelData.MainList.ModelName;
                controllerMethodName = this.baseUpdateComponent.modelData.MainList.PrintName;
              }
  
              this.baseDataService
                .GetFile(controllerName, controllerMethodName, {
                  ReportPars: [
                    {
                      Name: "ID"
                      , Value: this.baseUpdateComponent.Item.ID
                    }
                    , {
                      Name: "PrintMethod"
                      , Value: this.baseUpdateComponent.modelData.MainList.PrintName
                    }
                    , {
                      Name: "Otpremnica"
                      , Value: true
                    }
                    , {
                      Name: "StampamoCeneNaOtpremnici"
                      , Value: stampamoCeneNaOtpremnici
                    }
                  ],
                  WipsPars: {
                    parReportTitle: value.Title,
                    parReportSubtitle: value.SubTitle,
                    parPageNoYes: value.ShowPageCount,
                    parPageNoPosition: value.PageNoPosition,
                    parTimeZoneInfo: "Central Europe Standard Time",
                    parHeaderType: value.ReportHeaderTypes,
                    parPageFooterType: value.ReportPageTypes,
                    parCompanyAccounts: value.FirmaZrcs,
                    parIzvestajId: value.TipDokumenta,
                    parOdloziIUEregistrator: value.Eregistrator,
                  },
                })
                .subscribe((file) => {
                  let fileUrl = URL.createObjectURL(file);
                  window.open(fileUrl);
                });
              },
              () => { }
            );
          },
          () => { }
      );
      });
    }

 transport(){
    let modelData = new ModelData(null);
    modelData.ModalSize = ModalSize.Lg;
    modelData.UpdateComponent = GabaritiRobeComponent;


    let tezinaNeto: number = this.baseUpdateComponent.baseFormGroup.get('TezinaNeto').value;
    let tezinaNetoParameter = new QueryParameter('TezinaNeto', tezinaNeto);
    let tezinaNetoJedinicaMereId: number = this.baseUpdateComponent.baseFormGroup.get('TezinaNetoJedinicaMereId').value;
    let tezinaNetoJedinicaMereIdParameter = new QueryParameter('TezinaNetoJedinicaMereId', tezinaNetoJedinicaMereId);
    let tezinaBruto: number = this.baseUpdateComponent.baseFormGroup.get('TezinaBruto').value;
    let tezinaBrutoParameter = new QueryParameter('TezinaBruto', tezinaBruto);
    let tezinaBrutoJedinicaMereId: number = this.baseUpdateComponent.baseFormGroup.get('TezinaBrutoJedinicaMereId').value;
    let tezinaBrutoJedinicaMereIdParameter = new QueryParameter('TezinaBrutoJedinicaMereId', tezinaBrutoJedinicaMereId);
    let zapremina: number = this.baseUpdateComponent.baseFormGroup.get('Zapremina').value;
    let zapreminaParameter = new QueryParameter('Zapremina', zapremina);
    let zapreminaJedinicaMereId: number = this.baseUpdateComponent.baseFormGroup.get('ZapreminaJedinicaMereId').value;
    let zapreminaJedinicaMereIdParameter = new QueryParameter('ZapreminaJedinicaMereId', zapreminaJedinicaMereId);
    let pakovanjeVrsta: string = this.baseUpdateComponent.baseFormGroup.get('PakovanjeVrsta').value;
    let pakovanjeVrstaParameter = new QueryParameter('PakovanjeVrsta', pakovanjeVrsta);
    let pakovanjeKolicina: number = this.baseUpdateComponent.baseFormGroup.get('PakovanjeKolicina').value;
    let pakovanjeKolicinaParameter = new QueryParameter('PakovanjeKolicina', pakovanjeKolicina);

    let pozicija: string = this.baseUpdateComponent.baseFormGroup.get('Pozicija').value;
    let pozicijaParameter = new QueryParameter('Pozicija', pozicija);
    let crm: string = this.baseUpdateComponent.baseFormGroup.get('Crm').value;
    let crmParameter = new QueryParameter('Crm', crm);
    let vozilaIds: string = this.baseUpdateComponent.baseFormGroup.get('VozilaIds').value;
    let vozilaIdsParameter = new QueryParameter('VozilaIds', vozilaIds);
    let vozac: string = this.baseUpdateComponent.baseFormGroup.get('Vozac').value;
    let vozacParameter = new QueryParameter('Vozac', vozac);
    let napomenaTransporteri: string = this.baseUpdateComponent.baseFormGroup.get('NapomenaTransporteri').value;
    let napomenaTransporteriParameter = new QueryParameter('NapomenaTransporteri', napomenaTransporteri);
    let id: number = this.baseUpdateComponent.Item.ID;
    let idParameter = new QueryParameter('ID', id);

    let disabledFormParameter = new QueryParameter('DisabledForm', this.baseUpdateComponent.baseFormGroup.disabled);

    if(tezinaNetoJedinicaMereId == null){
      tezinaNetoJedinicaMereId = 1;
      tezinaNetoJedinicaMereIdParameter = new QueryParameter('TezinaNetoJedinicaMereId', tezinaNetoJedinicaMereId);
    }
    if(tezinaBrutoJedinicaMereId == null){
      tezinaBrutoJedinicaMereId = 1;
      tezinaBrutoJedinicaMereIdParameter = new QueryParameter('TezinaBrutoJedinicaMereId', tezinaBrutoJedinicaMereId);
    }
    if(zapreminaJedinicaMereId == null){
      zapreminaJedinicaMereId = 27;
      zapreminaJedinicaMereIdParameter = new QueryParameter('ZapreminaJedinicaMereId', zapreminaJedinicaMereId);
    }
    if(pakovanjeVrsta == null){
      pakovanjeVrsta = 'Koleta';
      pakovanjeVrstaParameter = new QueryParameter('PakovanjeVrsta', pakovanjeVrsta);
    }

    if(modelData){
      this.modalService.ShowModal(0, modelData, null, true, [
        tezinaNetoParameter,
        tezinaNetoJedinicaMereIdParameter,
        tezinaBrutoParameter,
        tezinaBrutoJedinicaMereIdParameter,
        zapreminaParameter,
        zapreminaJedinicaMereIdParameter,
        pakovanjeVrstaParameter,
        pakovanjeKolicinaParameter,
        pozicijaParameter,
        crmParameter,
        vozilaIdsParameter,
        vozacParameter,
        napomenaTransporteriParameter,
        idParameter,
        disabledFormParameter
      ])
      .result.then( result => {
        this.baseUpdateComponent.SetBagariteRobe = result;
        this.baseUpdateComponent.SaveItem();
      },
      () => {})
    }
  }

   UcitajAvanse() {
      let _modelData = this.modelDataService.GetModelDataByPath("odabir-avansa-v2");
      let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
      let idParameter = new QueryParameter("fakDokumentID", id);
      let urlParameter = new QueryParameter("url", "null");
      let master_id: number =
      this.baseUpdateComponent.baseFormGroup.get("MasterDokumID").value;
      let masterIDParameter = new QueryParameter("masterDokumID", master_id);
      let objekat_id: number =
      this.baseUpdateComponent.baseFormGroup.get("KomitentObjekatID").value;
      let objekatIDParameter = new QueryParameter("objekatID", objekat_id);

      if (_modelData) {
        this.modalService
          .ShowModal(0, _modelData, null, true, [
            idParameter,
            urlParameter,
            masterIDParameter,
            objekatIDParameter,
          ])
          .result.then(
            (item) => {
              this.baseUpdateComponent.Load(id).subscribe(() => {
                let parameterList: List<QueryParameter> = List([
                  new QueryParameter("Dokum", this.baseUpdateComponent.Item),
                ]);
                this.baseUpdateComponent.TransferParameters =
                this.baseUpdateComponent.TransferParameters.set(
                    1,
                    parameterList
                  );
                  this.baseUpdateComponent.baseInlineContainer.Parameters =
                  this.baseUpdateComponent.TransferParameters;
                  this.baseUpdateComponent.baseInlineContainer.baseDetailListSum.calculate();
              });
              // this.LoadItem(id)
              // .then((result)=>{
              //   let parameterList: List<QueryParameter> = List([new QueryParameter('Dokum', this.baseUpdateComponent.Item)]);
              //   this.baseUpdateComponent.TransferParameters = this.baseUpdateComponent.TransferParameters.set(1, parameterList);
              //   this.baseUpdateComponent.baseInlineContainer.Parameters=this.baseUpdateComponent.TransferParameters;
              //   this.baseUpdateComponent.baseInlineContainer.baseDetailListSum.calculate();
              //   console.log(result);
              // });
              // this.baseUpdateComponent.Load(id);
              // let parameterList: List<QueryParameter> = List([new QueryParameter('Dokum', this.baseUpdateComponent.Item)]);
              // this.baseUpdateComponent.TransferParameters = this.baseUpdateComponent.TransferParameters.set(1, parameterList);
              // this.baseUpdateComponent.baseInlineContainer.Parameters=this.baseUpdateComponent.TransferParameters;
              // this.baseUpdateComponent.baseInlineContainer.baseDetailListSum.calculate();
            },
            (reason) => {}
          );
      }
    }

      dodatnaPolja(){
        let modelData = new ModelData(null);
        modelData.ModalSize = ModalSize.Lg;
        modelData.UpdateComponent = PoljaZaVelikeLanceComponent;
    
        let brojNarudzbenice: string = this.baseUpdateComponent.baseFormGroup.get('BrojNarudzbenice').value;
        let brojNarudzbeniceParameter = new QueryParameter('BrojNarudzbenice', brojNarudzbenice);
        let datumNarudzbenice: Date = this.baseUpdateComponent.baseFormGroup.get('DatumNarudzbenice').value;
        let datumaNarudzbeniceParameter = new QueryParameter('DatumNarudzbenice', datumNarudzbenice);
        let brojPrijemnice: string = this.baseUpdateComponent.baseFormGroup.get('BrojPrijemnice').value;
        let brojPrijemniceParameter = new QueryParameter('BrojPrijemnice', brojPrijemnice);
        let datumPrijemnice: Date = this.baseUpdateComponent.baseFormGroup.get('DatumPrijemnice').value;
        let datumPrijemniceParameter = new QueryParameter('DatumPrijemnice', datumPrijemnice);
        let referencaKupcaNaDrugiDokument: string = this.baseUpdateComponent.baseFormGroup.get('ReferencaKupcaNaDrugiDokument').value;
        let referencaKupcaNaDrugiDokumentParameter = new QueryParameter('ReferencaKupcaNaDrugiDokument', referencaKupcaNaDrugiDokument);
        // let interniBrojZaRutiranje: string = this.baseUpdateComponent.baseFormGroup.get('InterniBrojZaRutiranje').value;
        // let interniBrojZaRutiranjeParameter = new QueryParameter('InterniBrojZaRutiranje', interniBrojZaRutiranje);
        let odgovornoLiceId: number = this.baseUpdateComponent.baseFormGroup.get('OdgovornoLiceID').value;
        let odgovornoLiceIdParameter = new QueryParameter('OdgovornoLiceID', odgovornoLiceId);
    
        let disabledFormParameter = new QueryParameter('DisabledForm', this.baseUpdateComponent.baseFormGroup.disabled);

        let _genericName = this.baseUpdateComponent.baseFormGroup.get('GenericName').value ;
        let trebaPrijemniceParameter= new QueryParameter();
        if (_genericName == 'ko' || _genericName == 'kz')
        {
          trebaPrijemniceParameter.Name= 'TrebaPrijemnice';
          trebaPrijemniceParameter.Value= 'false';
        }    
  
        if(modelData){
          this.modalService.ShowModal(0, modelData, null, true, [
            brojNarudzbeniceParameter,
            datumaNarudzbeniceParameter,
            brojPrijemniceParameter,
            datumPrijemniceParameter,
            referencaKupcaNaDrugiDokumentParameter,
            //interniBrojZaRutiranjeParameter,
            odgovornoLiceIdParameter,
            disabledFormParameter,
            trebaPrijemniceParameter
          ])
          .result.then( result => {
            this.baseUpdateComponent.SetPoljaZaVelikeLance = result;
            this.baseUpdateComponent.SaveItem();
          },
          () =>{})
        }
      }
      
      loadingEUInvoiceInXml: boolean = false;
      
      Download_XML_racuna() {

        if (!this.baseUpdateComponent.canDeactivate()) {
          this.modalService.ShowConfirmationDialog(
              "Obaveštenje",
              "Dokument nije sačuvan. Sačuvaj i preuzmi XML?",
              "question",
              ConfirmationDialogButtons.ConfirmCancel
          ).result.then((result) => {
              if (result === ConfirmationDialogButtons.ConfirmCancel || result === true) {
                  this.baseUpdateComponent.SaveItem();
                  if (!(this.baseUpdateComponent.baseInlineContainer &&
                      this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent &&
                      this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent &&
                      this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate())) {
                      this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SaveItem();
                  }
                  this.baseUpdateComponent.Item;
      
                  this.StartDownloadingProcess();
              }
          }).catch(() => {
              return;
          });
          return;
      }
    
      this.StartDownloadingProcess();
    }

    private StartDownloadingProcess() {
        if ((this.baseUpdateComponent.baseFormGroup.valid || this.baseUpdateComponent.baseFormGroup.disabled)){
    
        let _id: Number = this.baseUpdateComponent.Item.ID;
        // let fakDokumentIDQP = new QueryParameter("fakdokumentID", _id);
    
        // this.baseDataService.Get('FakDokument', 'EUInvoice', [new QueryParameter('fakdokumentID', _id)], null)
        //   .subscribe();
        let genericName : string = null;
    
        //if (This.podvrstaDokumentaGn)
          let _genericName = this.baseUpdateComponent.baseFormGroup.get('GenericName').value ;
          if (_genericName == 'ko' || _genericName == 'kz'){
            let _brojPovezanihDokumenata : Number = this.baseUpdateComponent.Item.UkBrPovezanihDokumenata;
            let _datumOd : Date = this.baseUpdateComponent.Item.DatumPrometaOd ? new Date(this.baseUpdateComponent.Item.DatumPrometaOd["year"], this.baseUpdateComponent.Item.DatumPrometaOd["month"]-1, this.baseUpdateComponent.Item.DatumPrometaOd["day"]) : null;
            let _datumDo : Date = this.baseUpdateComponent.Item.DatumPrometaDo ? new Date(this.baseUpdateComponent.Item.DatumPrometaDo["year"], this.baseUpdateComponent.Item.DatumPrometaDo["month"]-1, this.baseUpdateComponent.Item.DatumPrometaDo["day"]) : null;
    
            if ((_brojPovezanihDokumenata == 0 && _datumOd == null && _datumDo == null) ||
                (_brojPovezanihDokumenata == 0 && (_datumOd != null && _datumDo == null)) ||
                (_brojPovezanihDokumenata == 0 && (_datumOd == null && _datumDo != null)) ||
                ((_brojPovezanihDokumenata != 0 && (_datumOd != null && _datumDo == null)) ||
                (_brojPovezanihDokumenata != 0 && (_datumOd == null &&_datumDo != null)) ||
                (_brojPovezanihDokumenata != 0 && _datumOd != null && _datumDo != null))
                ){
    
              this.translateService.get(["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.NASLOV","EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.OPIS","EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.NASLOV","EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.OPIS"])
              .subscribe(translate => {
                this.modalService.ShowConfirmationDialog(
                  _genericName == 'ko' ? translate["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.NASLOV"] : translate["EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.NASLOV"]
                  , _genericName == 'ko' ? translate["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.OPIS"] : translate["EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.OPIS"]
                  ,'warning',ConfirmationDialogButtons.Ok);
              });
              return false;
            }
    
          }
    
        let parameters = { fakdokumentID: _id, genericName: _genericName, brojDecimala: this.baseUpdateComponent["brojDecimala"]}; //genericName
        this.loadingEUInvoiceInXml = true;
        this.baseDataService
          .GetFile("FakDokument", "EUInvoice", parameters)
          .subscribe((result: any) => {
            this.loadingEUInvoiceInXml = false;
            var lcType = result.type;
            let fileUrl: string = URL.createObjectURL(result);
            if (lcType == "application/xml; charset=utf-8") {
              // window.open(fileUrl);
              var link = document.createElement("a");
              link.download = this.baseUpdateComponent.Item.BrojDokumenta + ".xml";
              link.href = fileUrl;
              link.click();
            } else window.open(fileUrl);
          }
          ,error =>{
            this.loadingEUInvoiceInXml = false;
              // throw error;
              let _message;
              let translatedMessage: string = "";
              if(error instanceof HttpErrorResponse){
                _message = this.errorService.getServerMessage(error);
                if (_message instanceof ArrayBuffer){
                  _message = String.fromCharCode.apply(null, new Uint8Array(_message));
                  let message: string = _message;
                  if (message.includes("EDOKUMENT")){
                    let messageArray: string[] = message.split(';');
                    messageArray.forEach((element, index) => {
                      messageArray[index] = "FW.ERRORS." + element;
                    });
                    this.translateService.get(messageArray)
                    .subscribe(translate => {
                      translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                    });
                  }
                  else
                    translatedMessage = message;
                }
                else{
                  translatedMessage = this.errorService.getClientMessage(error);
                }
              }
                   this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translatedMessage, "warning", ConfirmationDialogButtons.Ok);
    
          });
        }
      }

  PonudaPredracun() {
    let _modelData =
      this.modelDataService.GetModelDataByPath("odabirdokumenata");
    let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
    let idParameter = new QueryParameter("fakDokumentID", id);
    let _url = this.router.url;
    let urlParameter = new QueryParameter("url", _url);
    let master_id: number =
    this.baseUpdateComponent.baseFormGroup.get("MasterDokumID").value;
    let masterIDParameter = new QueryParameter("masterDokumID", master_id);
    let objekat_id: number =
    this.baseUpdateComponent.baseFormGroup.get("KomitentObjekatID").value;
    let objekatIDParameter = new QueryParameter("objekatID", objekat_id);

    let brojStavki: number =
    this.baseUpdateComponent.baseInlineContainer["tempItems"].size;
    let brojStavkiParameter = new QueryParameter("BrojStavki", brojStavki);

    let isLocked: boolean = this.baseUpdateComponent.baseFormGroup.get("Useridlk").value != null;
    let isLockedParameter = new QueryParameter("isLocked", isLocked);
    if (_modelData) {
      this.modalService
        .ShowModal(0, _modelData, null, true, [
          idParameter,
          urlParameter,
          masterIDParameter,
          objekatIDParameter,
          isLockedParameter
        ])
        .result.then(
          (item) => {
            this.LoadItem(id); //ubačeno da ponovo učita FakDokument, trebalo jer kod KO/KZ kada se povezuje sa računom, ne učita novi broj povezanih dokumenata UkBrPovezanihDokumenata
            this.baseUpdateComponent.baseInlineContainer.baseDetailList.RefreshData();
            let idParameter = [new QueryParameter("id", id)];
            this.baseDataService.Get("FakDokument", "GetViewItemByID", idParameter, FakDokumentView)
            .subscribe((data: any) => {
              this.baseUpdateComponent.ItemSaved.emit(data);               
            })
            
          },
          (reason) => {}
        );
    }
  }

  async LoadItem(id: number) {
    await new Promise<void>((resolve, reject) => {
      this.baseUpdateComponent.Load(id);
      this.baseUpdateComponent.baseFormGroup.get('MasterDokumID').value
      resolve();
    });
  }

  PovezanoSaDokumentima() {
    let _modelData = this.modelDataService.GetModelDataByPath(
      "iskoriscen-dokument"
    );
    let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
    let idParameter = new QueryParameter("fakDokumentID", id);
    if (_modelData) {
      this.modalService
        .ShowModal(0, _modelData, null, true, [idParameter])
        .result.then(
          (item) => {},
          (reason) => {}
        );
    }
  }

  checkUnsavedChanges (
    modalFunction: () => void, 

  ) {
      if (!this.baseUpdateComponent.canDeactivate()) {
          this.modalService.ShowConfirmationDialog(
              "Obaveštenje",
              'Postoje promene u tekućim podacima. Da li želite da ih sačuvate pre nastavka?',
              "question",
              ConfirmationDialogButtons.ConfirmCancel 
          ).result.then((result) => {
              if (result === ConfirmationDialogButtons.ConfirmCancel || result === true) {
                  this.baseUpdateComponent.SaveItem(); 
                  modalFunction(); 
              }
             
          }).catch(() => {});
      } else {
          modalFunction(); 
      }
  }
  
}
